import React from "react";
import { ModeRendererProps } from "./types";

export function TinguelyJansenMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Horizon / ground (beachy amber) */}
      <rect x="0" y="720" width="794" height="403" fill={brand.amber} opacity="0.12" />
      <path d="M0 740 C 200 720 580 760 794 740 V760 H0 Z" fill={brand.amber} opacity="0.18" />

      {/* Wind lines */}
      {Array.from({ length: 5 }).map((_, i) => (
        <path
          key={i}
          d={`M40 ${180 + i * 46} C 220 ${170 + i * 46} 520 ${210 + i * 46} 754 ${190 + i * 46}`}
          stroke={brand.aqua}
          strokeOpacity={0.25}
          fill="none"
        />
      ))}

      {/* Strandbeest: simplified linkage + sail */}
      <g transform="translate(397 560)">
        {/* Sail */}
        <polygon points="0,-210 100,-80 -40,-80" fill="url(#sail)" opacity="0.9" />
        <line x1="0" y1="-210" x2="0" y2="-60" stroke={brand.white} strokeWidth="3" />

        {/* Chassis */}
        <line x1={-220} y1={40} x2={220} y2={40} stroke={brand.white} strokeWidth={4} />
        {[-180, -120, -60, 0, 60, 120, 180].map((x, i) => (
          <g key={i}>
            {/* upper triangle */}
            <line x1={x} y1={40} x2={x + 20} y2={-20} stroke={brand.white} strokeWidth="2" />
            <line x1={x + 20} y1={-20} x2={x + 60} y2={40} stroke={brand.white} strokeWidth="2" />
            {/* lower leg */}
            <line x1={x + 10} y1={40} x2={x + 35} y2={100} stroke={brand.white} strokeWidth="2" />
            <line x1={x + 35} y1={100} x2={x + 60} y2={40} stroke={brand.white} strokeWidth="2" />
            {/* foot */}
            <line x1={x + 30} y1={100} x2={x + 40} y2={100} stroke={brand.white} strokeWidth="4" />
          </g>
        ))}

        {/* Gears driving the beest */}
        <g opacity={0.9}>
          <use href="#gear" x={-140} y={40} />
          <use href="#gear" x={-100} y={40} transform="scale(0.8)" />
          <use href="#gear" x={100} y={40} />
          <use href="#gear" x={140} y={40} transform="scale(0.8)" />
        </g>

        {/* Axle */}
        <line x1={-220} y1={40} x2={220} y2={40} stroke={brand.violet} strokeWidth="2" strokeDasharray="6 8" />
      </g>

      {/* Kinetic scribble (Tinguely) */}
      {Array.from({ length: 12 }).map((_, i) => (
        <path
          key={i}
          d={`M${80 + i * 56} ${860 + (i % 3) * 10} q 20 -30 40 0 t 40 0 t 40 0`}
          stroke={brand.white}
          strokeOpacity={0.12}
          fill="none"
        />
      ))}

      {/* Frame bolts */}
      {Array.from({ length: 16 }).map((_, i) => (
        <circle key={i} cx={20 + i * 48} cy={1080 - (i % 2) * 18} r="3" fill={brand.white} opacity="0.5" />
      ))}
    </g>
  );
}
